document.addEventListener("DOMContentLoaded", () => {
  const filterWrapper = document.querySelector(".el-collection-filter");
  if (!filterWrapper) return;

  const toggleButton = filterWrapper.querySelector(".el-collection-filter--button");
  const container = filterWrapper.querySelector(".el-collection-filter--container");
  const tabs = filterWrapper.querySelectorAll(".el-collection-filter--tab");
  const optionsContainers = filterWrapper.querySelectorAll(".el-collection-filter--options");

  // Dropdown toggle
  toggleButton.addEventListener("click", (e) => {
    e.stopPropagation(); // Prevent closing immediately
    container.classList.toggle("active");
    toggleButton.classList.toggle("active");
  });

  // Tabs switch
  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.filter;

      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      optionsContainers.forEach(opt => {
        opt.classList.toggle("active", opt.dataset.filter === target);
      });
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener("click", (e) => {
    if (!filterWrapper.contains(e.target)) {
      container.classList.remove("active");
      toggleButton.classList.remove("active");
    }
  });
});

document.querySelectorAll('.el-price-slider').forEach(slider => {
  function update() {
    const percent = (slider.value - slider.min) / (slider.max - slider.min) * 100;
    slider.style.background = `linear-gradient(to right, #000 ${percent}%, #e5e5e5 ${percent}%)`;
  }

  slider.addEventListener('input', update);
  update();
});